import { decorate, injectable } from '@evertel/di'
import { NotificationPermission, NotificationPermissionResult, PushImplementation, GPCPushNotification, ScheduleNotificationOptions } from '../src/PushImplementation'

class MockPushImplementation implements PushImplementation {
    public pendingNotification: GPCPushNotification
    public onMessageCallback: (notification: GPCPushNotification) => void
    public onPermissionChangeCallback: (permission: NotificationPermission) => void
    public onNotificationClickedCallback: (notification: GPCPushNotification) => void
    getDisplayedNotifications(): Promise<GPCPushNotification[]> {
        throw new Error('Method not implemented.')
    }
    cancelNotifications(notificationIds: string[]): Promise<boolean> {
        throw new Error('Method not implemented.')
    }
    processPendingNotification(): void {
        throw new Error('Method not implemented.')
    }
    scheduleNotification(options: ScheduleNotificationOptions): Promise<string | undefined> {
        throw new Error('Method not implemented.')
    }
    setBadge?(count: number): Promise<void> {
        throw new Error('Method not implemented.')
    }
    calls = []

    async init() {
        this.calls.push('init')
    }

    promptForNotificationPermission(): NotificationPermissionResult {
        this.calls.push('promptForNotificationPermission')
        return Promise.resolve('default')
    }
    getCurrentNotificationPermission(): NotificationPermissionResult {
        this.calls.push('getCurrentNotificationPermission')
        return Promise.resolve('default')
    }
    getPushToken(): Promise<string> {
        this.calls.push('getPushToken')
        return Promise.resolve('test_token')
    }
    deletePushToken(): Promise<void> {
        throw new Error('Method not implemented.')
    }
    getInitialNotification(): Promise<GPCPushNotification> {
        throw new Error('Method not implemented.')
    }
    clearInitialNotification(): Promise<void> {
        throw new Error('Method not implemented.')
    }
    showLocalNotification(): Promise<void> {
        throw new Error('Method not implemented.')
    }
}

decorate(injectable(), MockPushImplementation)

export { MockPushImplementation }
